// @flow
import React from 'react';
import {useGuide} from '../../data/GuideProvider';
import Shell from './Shell';

const instructions = {
  ruby: {
    build: 'bundle install',
    run: 'ruby server.rb -o 0.0.0.0',
    entry: 'localhost:4242/checkout.html',
  },
  python: {
    build: 'pip3 install -r requirements.txt',
    run: 'export FLASK_APP=server.py\npython3 -m flask run --port=4242',
    entry: 'localhost:4242/checkout.html',
  },
  php: {
    build: 'composer install',
    run: 'php -S 127.0.0.1:4242 -docroot=public',
    entry: 'localhost:4242/public/checkout.html',
  },
  java: {
    build: 'mvn package',
    run:
      'java -cp target/stripe-checkout-1.0.0-SNAPSHOT-jar-with-dependencies.jar com.stripe.sample.Server',
    entry: 'localhost:4242/checkout.html',
  },
  node: {
    build: 'npm install',
    run: 'npm start',
    entry: 'localhost:4242/checkout.html',
  },
  go: {
    build: '',
    run: 'go run server.go',
    entry: 'localhost:4242/checkout.html',
  },
  dotnet: {
    build: 'dotnet restore',
    run: 'dotnet run',
    entry: 'localhost:4242/checkout.html',
  },
  html: {
    build: '',
    run: '',
  },
  react: {
    build: 'npm install',
    run: 'npm start',
    entry: 'localhost:3000/checkout',
  },
};

export function RunServerCommandShell() {
  const guide = useGuide();
  const {server} = guide.languages.active;
  const config = instructions[server];
  if (config && config.run) {
    return <Shell command={config.run} />;
  }
  return null;
}
